export default __webpack_public_path__ + "static/md-13c4124a630b14d99766649370ac1837.svg";